type Role = keyof typeof ROLES;
type Permission = (typeof ROLES)[Role][number];

const ROLES = {
    admin: [
        "delete:product",
        "view:product",
        "edit:product",
        "create:product",
        "delete:payment",
        "delete:order",
        "delete:user",
        "edit:user",
        "delete:email",
        "create:email",
        "delete:discount",
        "create:discount",
        "delete:comment",
        "switch_status:comment",
        "confirm:order",
        "cancel:order",
        "create:employees"
    ],
    editor: [
        "view:product",
        "edit:product",
        "create:product",
        "edit:user",
        "create:email",
        "create:discount",
        "switch_status:comment",
        "confirm:order",
        "cancel:order"
    ],
    supporter: [
        "view:product"
    ]
} as const;

export function hasPermission(
    role: Role,
    permission: Permission
) {
    return (ROLES[role] as readonly Permission[]).includes(permission);
}

